module.exports = __webpack_public_path__ + "img/uy-30_mfb5.prt.93b445c0.jpg";